
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"60","height":"60","viewBox":"0 0 60 60","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M18.48 49.814c-.47 0-.93-.149-1.32-.428a2.242 2.242 0 01-.9-2.2l1.99-11.549a.276.276 0 00-.07-.229l-8.43-8.173a2.214 2.214 0 01-.57-2.3c.27-.816.96-1.404 1.82-1.523l11.639-1.683c.08-.01.16-.06.19-.14l5.209-10.502a2.235 2.235 0 012.02-1.255c.86 0 1.64.478 2.02 1.254l5.209 10.504c.04.08.11.13.19.14l11.648 1.682c.86.12 1.55.707 1.82 1.523s.05 1.702-.57 2.3l-8.43 8.173a.24.24 0 00-.07.23l1.99 11.548a2.23 2.23 0 01-.9 2.2c-.7.508-1.61.568-2.379.17L30.168 44.1a.256.256 0 00-.24 0l-10.409 5.445c-.32.18-.68.27-1.04.27zm11.588-38a.24.24 0 00-.23.139l-5.21 10.503a2.221 2.221 0 01-1.7 1.224l-11.637 1.683c-.13.02-.18.11-.21.17-.02.069-.03.168.06.258l8.428 8.174c.53.517.77 1.254.65 1.99l-1.99 11.55c-.02.129.04.209.1.248.06.04.15.08.27.02l10.419-5.455a2.298 2.298 0 012.1 0l10.418 5.455c.12.06.21.02.27-.02.06-.04.12-.119.1-.248l-1.99-11.55c-.13-.726.12-1.472.65-1.99l8.419-8.174c.09-.09.09-.19.06-.259-.02-.07-.08-.15-.21-.169L37.197 23.68c-.73-.1-1.37-.567-1.7-1.224l-5.21-10.503a.236.236 0 00-.22-.14z"}})])
          )
        }
      }
    